// extracted by mini-css-extract-plugin
export var container = "Testimonials-module--container--3b583";
export var layout = "Testimonials-module--layout--02370";
export var description = "Testimonials-module--description--60d81";
export var sliderWrapper = "Testimonials-module--sliderWrapper--521da";
export var sliderControls = "Testimonials-module--sliderControls--49c23";